import validate from "/usr/src/app/content/n3-treatments-cbf70019-5d1a-4cbb-8830-24c9222edbe3/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-treatments-cbf70019-5d1a-4cbb-8830-24c9222edbe3/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}